let divMenuOpener = document.querySelector('.js-menu-opener');
let divHeader = document.querySelector('.js-header');

let lastScroll = 0;
window.addEventListener('scroll', scrollHeader);

function scrollHeader() {
    let currentScroll = window.scrollY || document.documentElement.scrollTop;
    ((lastScroll === 0 && currentScroll > 100) || (lastScroll === currentScroll) || (currentScroll < lastScroll && currentScroll > 100)) && currentScroll !== 0 ? divHeader.classList.add('header-sticky') : divHeader.classList.remove('header-sticky');
    currentScroll > lastScroll && currentScroll > 50 ? divHeader.classList.add('header-hidden') : divHeader.classList.remove('header-hidden');
    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
}

if (divMenuOpener) {
    divMenuOpener.addEventListener('click', function(event){
        event.preventDefault();
        document.body.classList.toggle('mobile-menu-opener');
    });
}

scrollHeader();

(function() {
    let headerPopupItem = document.querySelectorAll('.js-header-popup-item');
    let headerPopupBody = document.querySelectorAll('.js-header-popup-data');

    if (headerPopupItem) {
        headerPopupItem.forEach(function(item) {
            item.addEventListener('mouseover', function(event) {
                event.preventDefault();
                let type = item.dataset.type;

                headerPopupItem.forEach(function(menu) {
                    menu.classList.remove('active');
                    menu.classList.remove('active-mobile');
                });
                item.classList.add('active');
                item.classList.add('active-mobile');

                if (headerPopupBody) {
                    headerPopupBody.forEach(function(body) {
                        if (body.dataset.type === type) {
                            body.classList.add('active');
                            body.classList.add('active-mobile');
                        } else {
                            body.classList.remove('active');
                            body.classList.remove('active-mobile');
                        }
                    });
                }
            });
        });
    }
})();
